import { withInstall } from '../utils'
import _Tabs from './Tabs'
import './index.scss'

export const Tabs = withInstall(_Tabs)
export default Tabs
